export const saveToken = (token) => {
  localStorage.setItem("authToken", token);
  if (token) {
    // Store token expiration time for tracking
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp) {
        localStorage.setItem("tokenExpiry", payload.exp * 1000); // Convert to milliseconds
      }
    } catch (e) {
      // Token is not a JWT or invalid format, ignore
    }
  }
};

export const getToken = () => localStorage.getItem("authToken");

export const saveRefreshToken = (refreshToken) => {
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  }
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

export const clearRefreshToken = () => {
  localStorage.removeItem("refreshToken");
};

export const clearToken = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("tokenExpiry");
  clearRefreshToken();
};

/**
 * Check if token is expired
 * @param {number} bufferMinutes - Buffer time in minutes before expiration (default: 2)
 * @returns {boolean} true if token is expired or will expire within buffer time
 */
export const isTokenExpired = (bufferMinutes = 2) => {
  const expiry = localStorage.getItem("tokenExpiry");
  if (!expiry) {
    // If no expiry stored, try to decode token
    const token = getToken();
    if (!token) return true;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp) {
        const expiryTime = payload.exp * 1000;
        localStorage.setItem("tokenExpiry", expiryTime);
        // Check if expired or expires within buffer time (default 2 minutes)
        return Date.now() >= (expiryTime - bufferMinutes * 60 * 1000);
      }
    } catch (e) {
      // Can't decode, assume valid for now
      return false;
    }
    return false;
  }
  
  // Check if expired or expires within buffer time (default 2 minutes instead of 5)
  return Date.now() >= (parseInt(expiry, 10) - bufferMinutes * 60 * 1000);
};

/**
 * Get token expiration time in milliseconds
 * @returns {number|null}
 */
export const getTokenExpiry = () => {
  const expiry = localStorage.getItem("tokenExpiry");
  if (expiry) return parseInt(expiry, 10);
  
  const token = getToken();
  if (!token) return null;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp) {
      const expiryTime = payload.exp * 1000;
      localStorage.setItem("tokenExpiry", expiryTime);
      return expiryTime;
    }
  } catch (e) {
    // Invalid token format
  }
  return null;
};
